import {createFeatureSelector, createSelector} from "@ngrx/store";
import {FlyingFleetsFeatureKey} from "./flying-fleets.reducer";
import {FlyingFleet} from "../../models/FlyingFleet";

export const FlyingFleetsSelector = createFeatureSelector<FlyingFleet>(FlyingFleetsFeatureKey);

